"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatePreview = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var luxon_1 = require("luxon");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var GetFullName_1 = require("@CommonFrontendBackend/Utils/GetFullName");
var CrmPill_1 = require("Dashboard/TemplateListItem/CrmPill");
var useTemplatesDashboardTelemetry_1 = require("./useTemplatesDashboardTelemetry");
var GetProjectNameWithDefault_1 = require("@CommonFrontendBackend/Utils/GetProjectNameWithDefault");
var c = (0, BemBuilder_1.default)("template-preview");
var TemplatePreview = function (props) {
    var _a = props.template, name = _a.name, lastEditedAt = _a.lastEditedAt, createdAt = _a.createdAt, urls = _a.urls, user = _a.user;
    var _b = __read((0, react_1.useState)(false), 2), isOptionMenuOpen = _b[0], setOptionMenuOpen = _b[1];
    var destructiveOption = props.templateOptions.find(function (option) { return option.destructive == true; });
    var onClickOutside = new utils_1.OnClickOutside(["div[role='menu']"], function () {
        toggleOptionMenu(false);
    });
    var toggleOptionMenu = function (isOpen) {
        setOptionMenuOpen(isOpen);
        if (isOpen)
            onClickOutside.startListening();
        else
            onClickOutside.stopListening();
    };
    var optionMenuHandler = function (event) {
        event.stopPropagation();
        toggleOptionMenu(!isOptionMenuOpen);
    };
    var callbackHandler = function (event, callback) {
        event.stopPropagation();
        toggleOptionMenu(false);
        return callback(useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.PreviewModalOptionsMenu);
    };
    var formatDateTime = function (dateTime) {
        return luxon_1.DateTime.fromISO(dateTime).toLocaleString({
            dateStyle: "medium",
            timeStyle: "short",
            hourCycle: "h12",
        });
    };
    var closeHandler = function () {
        props.onModalClose();
    };
    var getSize = function () {
        var maxLength = props.templateOptions.reduce(function (acc, option) {
            return acc > option.displaytext.length ? acc : option.displaytext.length;
        }, 0);
        return maxLength > 15 ? "large" : "medium";
    };
    var editTemplate = function () {
        props.templateOptions
            .find(function (option) { return option.displaytext.includes("Edit"); })
            .callback(useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.PreviewModalEditButton);
    };
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("nav") },
            react_1.default.createElement("div", { className: c("nav-left") },
                react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "m", long: true }, "Template preview"),
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, (0, GetProjectNameWithDefault_1.getProjectNameWithDefault)(name))),
            react_1.default.createElement("div", { className: c("nav-right") },
                react_1.default.createElement(kaleidoscope_1.OptionMenu, { size: getSize(), isOpen: isOptionMenuOpen, button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, { size: icons_1.IconSize.Medium }), size: kaleidoscope_1.ButtonSize.Medium, onClick: optionMenuHandler }), autoStack: true },
                    props.templateOptions
                        .filter(function (option) { return !(option.hideInPreview || option.destructive); })
                        .map(function (option, index) { return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: index, onClick: function (e) { return callbackHandler(e, option.callback); }, icon: option.icon, disabled: !option.enabled, destructive: option.destructive && option.enabled, className: (0, classnames_1.default)("template-options", option.destructive && "is-destructive") }, option.displaytext)); }),
                    destructiveOption && react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
                    destructiveOption && (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function (e) { return callbackHandler(e, destructiveOption.callback); }, icon: destructiveOption.icon, disabled: !destructiveOption.enabled, destructive: destructiveOption.destructive && destructiveOption.enabled, className: (0, classnames_1.default)("template-options", destructiveOption.destructive && "is-destructive") }, destructiveOption.displaytext))),
                react_1.default.createElement(kaleidoscope_1.Button, { className: c("action-button"), onClick: editTemplate, openInSameTab: true }, "Edit this template"),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: closeHandler }))),
        react_1.default.createElement("div", { className: c("body") },
            react_1.default.createElement("iframe", { className: c("body-frame"), src: (0, CommonUtils_1.addParamsToUrl)(urls.collaboratorUrl, { hideCollaboratorNav: "true" }) }),
            react_1.default.createElement("div", { className: c("sidebar") },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("sidebar-panel"), c("sidebar-panel--createdby")) },
                    react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "m", long: true }, "Created by"),
                    react_1.default.createElement("div", { className: c("user") },
                        react_1.default.createElement(kaleidoscope_1.Avatar, { className: c("user-avatar"), size: kaleidoscope_1.AvatarSize.Large, firstName: user.firstName, lastName: user.lastName }),
                        react_1.default.createElement("div", { className: c("user-details") },
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, (0, GetFullName_1.buildName)(user.firstName, user.lastName)),
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "".concat(user.email))))),
                react_1.default.createElement("div", { className: c("sidebar-panel") },
                    react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "m", long: true }, "Last edited"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, formatDateTime(lastEditedAt))),
                react_1.default.createElement("div", { className: c("sidebar-panel") },
                    react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "m", long: true }, "Created"),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, formatDateTime(createdAt))),
                props.template.crmInfo.connected && (react_1.default.createElement("div", { className: c("sidebar-panel") },
                    react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "m", long: true }, "CRM details"),
                    react_1.default.createElement(CrmPill_1.CrmPill, { crmInfo: props.template.crmInfo })))))));
};
exports.TemplatePreview = TemplatePreview;
